import uuid from 'uuid/v4';
import { replaceAll } from './common';
import { requestDebug } from './api/debug';
import { trygTealium } from './tracking/trygTealium';

const ARRAY_TO_COMMA = 'arrayToComma';

const updateTrackingData = (flowStepNoData, userData, translations, flowHashData) => {
  const newFlowStepNoData = flowStepNoData;
  // Update tracking data.
  Object.keys(flowStepNoData).forEach(key => {
    const value = flowStepNoData[key];
    if (typeof value === 'string') {
      newFlowStepNoData[key] = replaceAll(value, translations, userData, false, false, false);
    } else if (Array.isArray(value)) {
      newFlowStepNoData[key] = value.map(currentValue => {
        if (typeof currentValue === 'string') {
          return replaceAll(currentValue, translations, userData, false, false, false);
        }
        return currentValue;
      });
    }
    if (flowHashData[ARRAY_TO_COMMA] && flowHashData[ARRAY_TO_COMMA].includes(key)) {
      if (newFlowStepNoData[key] && Array.isArray(newFlowStepNoData[key])) {
        newFlowStepNoData[key] = [newFlowStepNoData[key].join()];
      }
    }
  });
  return newFlowStepNoData;
};

const updateDynamicFields = (dynamicFields, flowStepNoData) => {
  const newFlowStepNoData = flowStepNoData;

  // Update tracking data.
  Object.keys(flowStepNoData).forEach(key => {
    if (dynamicFields[key]) {
      newFlowStepNoData[key] = dynamicFields[key];
    }
  });

  return newFlowStepNoData;
};

/**
 * Update current step with step all data if it is not there.
 * @param {Object} stepAll
 * @param {Object} flowStepNoData
 * @returns {Object}
 */
const updateStepAll = (stepAll, flowStepNoData) => {
  const newFlowStepNoData = flowStepNoData;

  // Update tracking data.
  Object.keys(stepAll).forEach(key => {
    if (!newFlowStepNoData[key]) {
      newFlowStepNoData[key] = stepAll[key];
    }
  });

  return newFlowStepNoData;
};


const getFlowHashData = () => {
  if (!window.trygTealiumData) {
    return {};
  }
  const { flowHashData } = window.trygTealiumData;
  return flowHashData;
};

export const getFlowStepNo = (currentHash) => {
  const step = currentHash.replace(/\//g, '.');
  const stepNo = `step${step}`;
  const flowHashData = getFlowHashData();

  return flowHashData[stepNo] ? (flowHashData[stepNo].flow_step_no || stepNo) : stepNo;
};

export const updateTrygTealium = (currentHash, userData, translations) => {
  const flowHashData = getFlowHashData();
  if (!userData) {
    return;
  }
  const newUserData = userData;
  const step = currentHash.replace(/\//g, '.');
  const stepNo = `step${step}`;
  const flowStepNo = getFlowStepNo(currentHash);
  const { chosenPackage, policyList } = userData;
  if (flowHashData[stepNo] && flowHashData[stepNo].noTracking) {
    return;
  }
  if (flowStepNo === 'stepfinish') {
    if (newUserData.basketList.length === 1) {
      if (typeof chosenPackage !== 'undefined') {
        newUserData.price = userData.quotes[chosenPackage].totalOfferedPrice.priceWithFee;
        newUserData.coverageCodes =
          chosenPackage.indexOf('a', userData.basketList[0].length) === -1 ?
            '' :
            userData.quotes[chosenPackage].usedParams.coverageCodes;
      } else {
        newUserData.price = userData.quotes.totalOfferedPrice.priceWithFee;
        newUserData.coverageCodes = userData.quotes.usedParams.coverageCodes;
      }
    }
    newUserData.countBasketList = userData.basketList.length;
    newUserData.purchase_policy_number = [];
    if (policyList) {
      Object.keys(policyList).forEach(key => {
        newUserData.purchase_policy_number.push(policyList[key]);
        newUserData.transaction_id = policyList[key];
      });
    } else {
      newUserData.transaction_id = uuid();
    }
    if (newUserData.transaction_id.length > 20) {
      newUserData.transaction_id = newUserData.transaction_id.substr(1, 20);
    }
    const paymentFrequency =
      userData[`paymentFrequency-${newUserData.basketList[0]}`] ?
        userData[`paymentFrequency-${newUserData.basketList[0]}`] :
        userData.paymentFrequency;
    newUserData.yearlyPrice =
      paymentFrequency * newUserData.price.replace(',', '');
    newUserData.paymentFrequencyText =
      userData[`paymentFrequency-${newUserData.basketList[0]}Text`] ?
        userData[`paymentFrequency-${newUserData.basketList[0]}Text`] :
        userData.paymentFrequencyText;
    const listPrice =
      userData.quotes.totalListPrice ?
        userData.quotes.totalListPrice.priceWithFee :
        userData.quotes[userData.chosenPackage].priceApiResponse[0].listPrice.priceWithFee;
    const offerPrice = userData.quotes.totalListPrice ?
      userData.quotes.totalOfferedPrice.priceWithFee :
      userData.quotes[userData.chosenPackage].priceApiResponse[0].offeredPrice.priceWithFee;
    newUserData.purchase_total_discount =
      paymentFrequency * (listPrice.replace(',', '') - offerPrice.replace(',', ''));
    if (!newUserData.yearlyPrice || parseInt(newUserData.yearlyPrice, 10) === 0) {
      requestDebug({
        type: 'SPP',
        title: 'Zero amount on yearly price',
        data: {
          newUserData,
          paymentFrequency,
          listPrice,
          offerPrice,
        },
      });
    }
  }
  newUserData.page_product_name = flowHashData.page_product_name;
  if (flowHashData[stepNo]) {
    if (flowHashData.stepAll) {
      flowHashData[stepNo] = updateStepAll(flowHashData.stepAll, flowHashData[stepNo]);
    }
    if (flowHashData.dynamicFields) {
      flowHashData[stepNo] = updateDynamicFields(flowHashData.dynamicFields, flowHashData[stepNo]);
    }
    flowHashData[stepNo] =
      updateTrackingData(flowHashData[stepNo], newUserData, translations, flowHashData);
  }
  if (flowHashData.partnerWidget && typeof window.trygTealiumData.tealiumData !== 'undefined') {
    trygTealium.processFlowHashPages(stepNo, flowHashData[stepNo]);
  }
};

export const sendTrygTealium = (stepNo, userData, translations) => {
  const newUserData = userData;
  const flowHashData = getFlowHashData();
  newUserData.page_product_name = flowHashData.page_product_name;
  if (flowHashData[stepNo]) {
    if (flowHashData.dynamicFields) {
      flowHashData[stepNo] = updateDynamicFields(flowHashData.dynamicFields, flowHashData[stepNo]);
    }
    flowHashData[stepNo] =
      updateTrackingData(flowHashData[stepNo], newUserData, translations, flowHashData);
    if ((!window.Drupal || !window.Drupal.behaviors || !window.Drupal.behaviors.trygTealium) &&
      (!window.trygTealiumData || !window.trygTealiumData.tealiumData)) {
      return;
    }
    if (flowHashData.partnerWidget) {
      trygTealium.processFlowHashPages(stepNo, flowHashData[stepNo]);
    } else {
      setTimeout(
        () => {
          window.Drupal.behaviors.trygTealium.sendFlowHashPages(flowHashData[stepNo]);
        },
        50
      );
    }
  }
};

export const setWindowTrygTealium = (packageData, userData) => {
  if (packageData.trygTealium) {
    const { trygTealium: { flowHashData, tealiumData } } = packageData;
    window.trygTealiumData = { flowHashData, tealiumData };
    if (flowHashData.partnerWidget && typeof tealiumData !== 'undefined') {
      trygTealium.attach();
    }
    if (flowHashData.startStep) {
      updateTrygTealium(flowHashData.startStep, userData, {});
    }
  }
};

export const setTrygTealium = (data) => {
  if ((!window.Drupal || !window.Drupal.behaviors || !window.Drupal.behaviors.trygTealium) &&
    (!window.trygTealiumData || !window.trygTealiumData.tealiumData)) {
    return;
  }
  if (!window.trygTealiumData.tealiumData) {
    Object.keys(data).forEach(key => {
      window.Drupal.behaviors.trygTealium.setUtagData(key, data[key]);
    });
  } else {
    Object.keys(data).forEach(key => {
      trygTealium.setUtagData(key, data[key]);
    });
  }
};

export const getTrygTealium = () => {
  return new Promise((resolve) => {
    const retry = (attempt) => {
      if ((!window.utag_data || !window.utag_data.tealium_environment
        || !window.utag_data.mouseflow_session_id) && attempt > 0) {
        setTimeout(() => {
          retry(attempt - 1);
        }, 500);
      } else {
        resolve(window.utag_data || {
          tealium_environment: 'test',
          mouseflow_session_id: 'test',
        });
      }
    };

    retry(10);
  });
};
